(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/created-tooltip-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/created-tooltip-event.js');
"use strict";

const VerifyType = svs.components.tbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.tbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.onboarding.core.events.BaseTooltipEvent;
const TooltipEventType = svs.components.onboarding.core.events.constants.TooltipEventType;
class CreatedTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      tooltip: VerifyType.Element
    });
    super(TooltipEventType.Created, props);
  }
}

setGlobal('svs.components.onboarding.core.events.CreatedTooltipEvent', CreatedTooltipEvent);

 })(window);